export default __webpack_public_path__ + "static/media/Aura-Egg__57.3eabd9cb.png";